export default __webpack_public_path__ + "static/media/search-white.bf25f974.svg";